import { CapoPlugin } from "/Users/prakash/Projects/personal/onlyfans-downloader/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];